import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { IUfItem } from "app/core/ufs-list/uf-list.types";
import { UfsListService } from "app/core/ufs-list/ufs-list.service";
import { map, Observable, startWith } from "rxjs";

@Component({
    selector: "ufs-autocomplete",
    templateUrl: "ufs-autocomplete.component.html",
    standalone: false
})
export class UfsAutoCompleteComponent implements OnInit, OnChanges {
  ufs: IUfItem[] = [];
  filteredUfs: Observable<IUfItem[]>;

  @Input() label: string = "UF";
  @Input() required: boolean = false;
  @Input() ufController = new FormControl();
  @Input() removeUfInList = "";
  @Input() appearance = "";
  @Input() showUfMode: "ufNome" | "ufSigla" = "ufNome";
  @Input() initialValue;

  @Output() ufSelected = new EventEmitter<IUfItem>();

  constructor(private _ufsListService: UfsListService) {}

  ngOnInit(): void {
    this._ufsListService.ufList$.subscribe((val) => {
      this.removeUfInListFn(val);

      if (this.initialValue) {
        const initialUf = val.filter(uf => uf.sigla === this.initialValue)[0];
        this.ufController.setValue(initialUf);
      }
    });

    this.filteredUfs = this.ufController.valueChanges.pipe(
      startWith(""),
      map((value) => {
        const name =
          typeof value === "string" ? value : (value as IUfItem)?.nome;
        return name ? this._filter(name as string) : this.ufs?.slice();
      })
    );
  }

  removeUfInListFn(val) {
    if (this.removeUfInList && val) {
      this.ufs = val.filter(
        (uf) => uf.sigla !== this.removeUfInList.toUpperCase()
      );

      return;
    }

    this.ufs = val;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.removeUfInList) {
      this.removeUfInListFn(this.ufs);
    }
  }

  displaySiglaFn(uf: IUfItem): string {
    return uf && uf.nome ? uf.sigla : "";
  }

  displayNameFn(uf: IUfItem): string {
    return uf && uf.nome ? uf.nome : "";
  }

  private _filter(name: string): IUfItem[] {
    const filterValue = name.toLowerCase();

    return this.ufs.filter((option) =>
      this.convertToSlug(option.nome)
        .toLowerCase()
        .includes(this.convertToSlug(filterValue))
    );
  }

  handleChange(value) {
    this.ufSelected.emit(value);
  }

  convertToSlug = (text) => {
    const a = "àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;";
    const b = "aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------";
    const p = new RegExp(a.split("").join("|"), "g");
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special chars
      .replace(/&/g, "-and-") // Replace & with 'and'
      .replace(/[\s\W-]+/g, "-"); // Replace spaces, non-word characters and dashes with a single dash (-)
  };
}
